import { connect } from 'react-redux'
import { actions } from '@opallabs/wormhole'
import loadBudget from '../utils/loadBudget'
import { ContentDetailsPopover } from '.'

const mapStateToProps = (state, props) => ({
  budget: loadBudget({ state, id: props.id, context: 'post' }),
})

const mapDispatchToProps = (dispatch) => ({
  getBudget: (options) => {
    dispatch(actions.getBudget(options))
  },
})

const ConnectedContentDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentDetailsPopover)

export default ConnectedContentDetails
